<template>
  <div class="mt-2">
    <b-form-checkbox
      :checked="value"
      @change="$emit('input', $event)"
    >
      {{ $t('settings.redirectOldUrl') }}
    </b-form-checkbox>
    <b-form-text v-if="!value" text-variant="danger">
      {{ $t('settings.redirectOldUrlOffHint') }}
    </b-form-text>
  </div>
</template>

<script>
export default {
  name: 'RedirectOldUrlCheckbox',
  props: {
    value: { type: Boolean, default: true },
  },
};
</script>
